export enum Sort{
    RELEVANT  = "RELEVANT",
    APPLIED_DATE = "APPLIED_DATE",
    EXP_AND_RELEVANT = "EXP_AND_RELEVANT",
    EXP_AND_APPLIED_DATE = "EXP_AND_APPLIED_DATE"
}

export default interface SortEnum{
    sort: Sort
}